const colors = require("colors");
const TruffleError = require("truffle-error");
const inherits = require("util").inherits;

inherits(BuildError, TruffleError);

function BuildError(message) {
  message = "Error building:\n\n" + message + "\n\n" + colors.red("Build failed. See above.");
  BuildError.super_.call(this, message);
}

module.exports = BuildError;



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-core/lib/errors/builderror.js
// module id = 2734
// module chunks = 0 1